// extracted by mini-css-extract-plugin
export default {"container":"page-internal-bid-form_container__XYOTi"};